import { createSlice } from "@reduxjs/toolkit";

export interface ChatStore {
  uuid: string;
  user: {
    _id: string;
    name: string;
    email: string;
  };
}

export interface Action {
  payload: ChatStore;
  type: string;
}

const initialState: ChatStore = {
  uuid: "",
  user: {
    _id: "",
    name: "",
    email: "",
  },
};

const alertSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setChat: (state, action: Action) => {
      state = { ...action.payload };
      return state;
    },
  },
});

export const { setChat } = alertSlice.actions;

export default alertSlice;
